import { BrandIdentitySourceDataTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
const isBrandIdentitySourceData = data => data.__typename === BrandIdentitySourceDataTypename;
export const getSourceType = source => {
  var _source$data, _source$data2, _source$data3, _source$data4, _source$data5, _source$data6, _source$data7, _source$data8, _source$data9, _source$data10, _source$data11;
  if (!source.data) {
    return undefined;
  }

  // Check for WEBSITE (both legacy __typename and new source property)
  if ((_source$data = source.data) !== null && _source$data !== void 0 && (_source$data = _source$data.__typename) !== null && _source$data !== void 0 && _source$data.includes('WebsiteSourceData') || ((_source$data2 = source.data) === null || _source$data2 === void 0 ? void 0 : _source$data2.source) === 'WEBSITE') {
    return 'WEBSITE';
  }

  // Check for APP (both legacy __typename and new source property)
  if ((_source$data3 = source.data) !== null && _source$data3 !== void 0 && (_source$data3 = _source$data3.__typename) !== null && _source$data3 !== void 0 && _source$data3.includes('AppSourceData') || ((_source$data4 = source.data) === null || _source$data4 === void 0 ? void 0 : _source$data4.source) === 'APP') {
    return 'APP';
  }

  // Check for CRM_OBJECT (both legacy __typename and new source property)
  if ((_source$data5 = source.data) !== null && _source$data5 !== void 0 && (_source$data5 = _source$data5.__typename) !== null && _source$data5 !== void 0 && _source$data5.includes('CrmObjectSourceData') || ((_source$data6 = source.data) === null || _source$data6 === void 0 ? void 0 : _source$data6.source) === 'CRM_OBJECT') {
    return 'CRM_OBJECT';
  }

  // Check for AI_SKILL (both legacy __typename and new source property)
  if ((_source$data7 = source.data) !== null && _source$data7 !== void 0 && (_source$data7 = _source$data7.__typename) !== null && _source$data7 !== void 0 && _source$data7.includes('AISkillSourceData') || ((_source$data8 = source.data) === null || _source$data8 === void 0 ? void 0 : _source$data8.source) === 'AI_SKILL') {
    return 'AI_SKILL';
  }

  // Check for FILE_UPLOAD (both legacy __typename and new source property)
  if ((_source$data9 = source.data) !== null && _source$data9 !== void 0 && (_source$data9 = _source$data9.__typename) !== null && _source$data9 !== void 0 && _source$data9.includes('FileUploadSourceData') || (_source$data10 = source.data) !== null && _source$data10 !== void 0 && (_source$data10 = _source$data10.__typename) !== null && _source$data10 !== void 0 && _source$data10.includes('FileUploadCitation') || ((_source$data11 = source.data) === null || _source$data11 === void 0 ? void 0 : _source$data11.source) === 'FILE_UPLOAD') {
    return 'FILE_UPLOAD';
  }
  if (isBrandIdentitySourceData(source.data)) {
    return 'BRAND_IDENTITY';
  }
  return undefined;
};